(function (app, ng) {

    app.component("profilePicture",
        {
            templateUrl: "/App/Client/Components/profilepicture-template.html",
            controller: profilePictureController,
            require: {
                clientSidebar: "^clientSidebar"
            }
        });

    profilePictureController.$inject = ["personApi"];
    function profilePictureController(personApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                updateProfilePicture: updateProfilePicture,
                removeProfilePicture: removeProfilePicture
            });

        function updateProfilePicture(file) {
            if (file !== null) {
                $ctrl.ui.loading = true;
                var payload = new FormData();
                payload.append("profilePic", $ctrl.profilePicture, $ctrl.profilePicture.name);

                personApi.updateProfilePicture($ctrl.client.Person.Id, payload).then(function () {
                    personApi.getProfilePicture($ctrl.client.Person.Id).then(function (response) {
                        $ctrl.profilePicture = URL.createObjectURL(response);
                        $ctrl.ui.loading = false;
                    });
                }, function () {
                    $ctrl.ui.loading = false;
                });
            }
        }

        function removeProfilePicture() {
            $ctrl.profilePicture = null;
            return personApi.removeProfilePicture($ctrl.client.Person.Id);
        }

        this.$onInit = function() {
            $ctrl.client = this.clientSidebar.parent.client;

            $ctrl.ui.loading = true;
            personApi.getProfilePicture($ctrl.client.Id).then(function (response) {
                    $ctrl.profilePicture = URL.createObjectURL(response);
                },
                function () {
                    $ctrl.profilePicture = null;
                }).finally(function() {
                $ctrl.ui.loading = false;
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line